<div [ngClass]= "getClass(numero)" [ngStyle]="{ 'background-color': color}">{{numero}}</div>
